import { useMutation, useQuery, useQueryClient } from "react-query";
import apiService from "../../service/apiService";
import { useCookie } from "../useCookie";
import { useToast } from "../useToast";
import { general } from "../../locales/general";
import { useMemo } from "react";

export const useServiceSubCategoriesQuery = () => {
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();
  const { toastError, toastSuccess } = useToast();

  const { data, isLoading } = useQuery<ServiceCategory[]>(
    ["getAllServiceSubCategories"],
    (query) => {
      return apiService.MakeGetRequest(
        "service-categories/sub-categories",
        token,
      );
    },
  );
  const deleteServiceCategory = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(
      `service-categories/sub-categories/${id}`,
      token,
    );
  });

  const arrangedSubCategories = useMemo(() => {
    const results = data?.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
    return results || [];
  }, [data]);

  return {
    categories: arrangedSubCategories,
    isLoading: isLoading,
    deleteServiceCategory(id: string) {
      deleteServiceCategory.mutate(id, {
        onError(error) {
          toastError(general.fr.message.operationFailed);
        },
        onSuccess() {
          toastSuccess(general.fr.message.categoryDeleted);
          queryClient.invalidateQueries("getAllServiceSubCategories");
        },
      });
    },
    mutating: deleteServiceCategory.isLoading,
  };
};
